import type { DashboardWidgetPool, DashboardWidgetRegistration } from '@h20-shared/dashboards';
import {
    FILTER_WIDGET_KEY,
    GRID_WIDGET_KEY,
    HTML_WIDGET_KEY,
    KPI_WIDGET_KEY,
    PROVENANCE_WIDGET_KEY,
    TABLEAU_WIDGET_KEY,
} from './dashboard-widget-keys';
import { DashboardFilterWidget } from './filter/dashboard-filter.widget';
import { FILTER_CONFIG_SCHEMA } from './filter/dashboard-filter.schema';
import type { FilterWidgetConfig } from './filter/dashboard-filter.schema';
import { DashboardGridWidget } from './grid/dashboard-grid.widget';
import { GRID_CONFIG_SCHEMA } from './grid/dashboard-grid.schema';
import type { GridWidgetConfig } from './grid/dashboard-grid.schema';
import { DashboardHtmlWidget } from './html/dashboard-html.widget';
import { HTML_CONFIG_SCHEMA } from './html/dashboard-html.schema';
import type { HtmlWidgetConfig } from './html/dashboard-html.schema';
import { DashboardKpiWidget } from './kpi/dashboard-kpi.widget';
import { KPI_CONFIG_SCHEMA } from './kpi/dashboard-kpi.schema';
import type { KpiWidgetConfig } from './kpi/dashboard-kpi.schema';
import { DashboardProvenanceWidget } from './provenance/dashboard-provenance.widget';
import { DashboardTableauWidget } from './tableau/dashboard-tableau.widget';
import { TABLEAU_CONFIG_SCHEMA } from './tableau/dashboard-tableau.schema';
import type { TableauWidgetConfig } from './tableau/dashboard-tableau.schema';

const tableau: DashboardWidgetRegistration<TableauWidgetConfig> = {
    component: DashboardTableauWidget,
    sidebarLabel: 'Dashboard.EditMode.Sidebar.Tableau',
    dataBound: false,
    configSchema: TABLEAU_CONFIG_SCHEMA,
};

const kpi: DashboardWidgetRegistration<KpiWidgetConfig> = {
    component: DashboardKpiWidget,
    sidebarLabel: 'Dashboard.EditMode.Sidebar.KPI',
    dataBound: true,
    configSchema: KPI_CONFIG_SCHEMA,
};

const filter: DashboardWidgetRegistration<FilterWidgetConfig> = {
    component: DashboardFilterWidget,
    sidebarLabel: 'Dashboard.EditMode.Sidebar.Filter',
    dataBound: true,
    configSchema: FILTER_CONFIG_SCHEMA,
};

const grid: DashboardWidgetRegistration<GridWidgetConfig> = {
    component: DashboardGridWidget,
    sidebarLabel: 'Dashboard.EditMode.Sidebar.Grid',
    dataBound: true,
    configSchema: GRID_CONFIG_SCHEMA,
};

const html: DashboardWidgetRegistration<HtmlWidgetConfig> = {
    component: DashboardHtmlWidget,
    sidebarLabel: 'Dashboard.EditMode.Sidebar.HTML',
    dataBound: false,
    hasTitle: false,
    replaces: 'HTML',
    configSchema: HTML_CONFIG_SCHEMA,
};

const provenance: DashboardWidgetRegistration = {
    component: DashboardProvenanceWidget,
    sidebarLabel: 'Dashboard.EditMode.Sidebar.Provenance',
    dataBound: true,
    hasTitle: false,
};

/** Pass to `<pulse-dashboard [angularWidgets]>`, or spread alongside an app's own widgets. */
export const SHARED_DASHBOARD_WIDGETS: DashboardWidgetPool = {
    [TABLEAU_WIDGET_KEY]: tableau,
    [KPI_WIDGET_KEY]: kpi,
    [FILTER_WIDGET_KEY]: filter,
    [GRID_WIDGET_KEY]: grid,
    [HTML_WIDGET_KEY]: html,
    [PROVENANCE_WIDGET_KEY]: provenance,
};
